// components/views/LibraryView.jsx
import { Callout, Icons } from '../UI';
import { REF_DOCS, fmtSize } from '../../utils/constants';

function LibSection({ title, docs, library }) {
  return (
    <div className="card">
      <h3 className="card-title">{title}</h3>
      {docs.map(doc => {
        const saved = library[doc.key];
        return (
          <div key={doc.key} className="lib-doc-card">
            <div className="lib-doc-icon">{saved ? '✓' : '📄'}</div>
            <div className="lib-doc-body">
              <div className="lib-doc-name" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {doc.label}
                <span style={{
                  fontSize: 9.5, padding: '2px 7px', borderRadius: 99,
                  background: 'var(--navy-100)', color: 'var(--navy-600)', fontWeight: 700,
                }}>GoldenScope Managed</span>
              </div>
              <div className="lib-doc-meta">
                {saved
                  ? <span style={{ color: 'var(--green-600)' }}>
                      ✓ {saved.name}{saved.size ? ' · ' + fmtSize(saved.size) : ''} — available to all agencies
                    </span>
                  : <span style={{ color: 'var(--slate-400)' }}>
                      {doc.desc} · Not yet loaded by administrator
                    </span>
                }
              </div>
            </div>
            {/* No upload/remove controls — managed by GoldenScope super admin only */}
          </div>
        );
      })}
    </div>
  );
}

export default function LibraryView({ library }) {
  const count = REF_DOCS.filter(d => library[d.key]).length;

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Reference Library</h1>
          <p className="page-subtitle">SCM reference documents managed by GoldenScope — available to all agencies automatically</p>
        </div>
      </div>

      {count > 0
        ? <Callout type="teal" style={{ marginBottom: 20 }}>
            {count} SCM document{count !== 1 ? 's' : ''} loaded. Penny will reference and cite these in all drafts and compliance reviews.
          </Callout>
        : <Callout type="blue" style={{ marginBottom: 20 }}>
            SCM reference documents are managed by the GoldenScope administrator and will appear here automatically once loaded.
          </Callout>
      }

      <LibSection
        title="SCM Reference Documents"
        docs={REF_DOCS}
        library={library}
      />
    </div>
  );
}
